import { useCallback } from "react";

import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { apiClient } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";
import { chartOfAccountTypeLabels } from "../chart-of-account-type";

export const ParentChartOfAccountSelect = ({
  accountType = null,
  excludeSubtreeId = null,
  ...props
}) => {
  const fetchChartOfAccounts = useCallback(async () => {
    const params = {};

    // For UPDATE scenario: exclude the node and all its descendants
    if (excludeSubtreeId) {
      params.id = excludeSubtreeId;
    }

    // For CREATE scenario: pass account type to filter parents
    if (accountType) {
      params.type = accountType;
    }

    const {
      data: { data },
    } = await apiClient.get("chart-of-accounts/allowed-parents", {
      params,
    });

    return data;
  }, [excludeSubtreeId, accountType]);

  return (
    <CustomAutocomplete
      fetchOptions={fetchChartOfAccounts}
      getOptionLabel={(option) => `${option.code} - ${option.name}`}
      renderOption={(props, option) => {
        // eslint-disable-next-line react/prop-types
        const { key, ...otherProps } = props;
        return (
          <Box component="li" key={key} {...otherProps}>
            <Box>
              <Typography variant="body2">
                {option.code} - {option.name}
              </Typography>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                {chartOfAccountTypeLabels[option.type]}
              </Typography>
            </Box>
          </Box>
        );
      }}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};

ParentChartOfAccountSelect.propTypes = {
  accountType: PropTypes.string,
  excludeSubtreeId: PropTypes.string,
};
